import { SPECIALS_FACET_ID } from '@app/components/pages/search-results/constants';

/**
 * Filter the facets based on a boolean
 * @param {boolean} shouldDisplaySpecialsFacets option to filter the facets
 * @param {object[]} facets array of facets as objects
 * @returns facet array filtered
 */
export const filterSpecialFacets = (shouldDisplaySpecialsFacets, facets) => {
  return shouldDisplaySpecialsFacets
    ? facets
    : facets.filter(
        ({ facetId }) =>
          facetId.toUpperCase() !== SPECIALS_FACET_ID.toUpperCase()
      );
};
